import { coinIcons } from '../constants';

type CoinSymbol = keyof typeof coinIcons;

export const getCoinIcon = (symbol: CoinSymbol | undefined, classNames: string) => {
  if (!symbol || !coinIcons[symbol]) return null;
  return (
    <img alt="Coin Icon" data-testid="coin-icon" src={coinIcons[symbol]} className={classNames} />
  );
};
